<template>
  <div class="is-top">
    <div class="tile is-ancestor">
      <div class="tile is-parent is-5 is-offset-custom-home-desktop">
        <article class="tile is-child box bottom-padding-box">
          <h1 class="title"><i class="fa fa-files-o"></i> Uploads</h1>
          <div class="block is-flex">
            <table class="table is-striped is-narrow ">
              <thead>
              <tr>
                <th></th>
                <th>Size</th>
                <th>DLs</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="file in uploadedfiles">
                <td>{{ file.name }}</td>
                <td class="has-text-centered">{{ file.size | prettyBytes }}</td>
                <td class="has-text-centered">{{ file.downloads | formatNumber }}</td>
                <td><a :href="'/file/'+file.randname"><i :style="'margin-left:18%;'"
                                                         class="fa fa-lg fa-cloud-download"></i> </a></td>
              </tr>
              </tbody>
            </table>
          </div>
          <ul class="pagination-list">
            <li class="pagination-next" v-on:click="next -= 1;" v-if="next>0"><i class="fa fa-angle-double-left"></i>
            </li>
            <li class="pagination-next " v-for="n in (Math.ceil(pagetop/10))" v-show="n<=(next+1)*5 && n>next*5"
                v-on:click="fetchPage(n, $event)">{{ n }}
            </li>
            <li class="pagination-next" v-on:click="next += 1;" v-if="(next+1)*5<Math.ceil(pagetop/10)"><i
              class="fa fa-angle-double-right"></i></li>
          </ul>
        </article>
      </div>
      <div class="tile is-parent is-5">
        <article class="tile is-child box">
          <h1 class="title"><i class="fa fa-files-o"></i> Popular Uploads</h1>
          <div class="block is-flex">
            <table class="table is-striped is-narrow ">
              <thead>
              <tr>
                <th></th>
                <th>Size</th>
                <th>DLs</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="file in popularfiles">
                <td>{{ file.name }}</td>
                <td class="has-text-centered">{{ file.size | prettyBytes }}</td>
                <td class="has-text-centered">{{ file.downloads | formatNumber }}</td>
                <td><a :href="'/file/'+file.randname"><i :style="'margin-left:18%;'"
                                                         class="fa fa-lg fa-cloud-download"></i> </a></td>
              </tr>
              </tbody>
            </table>
          </div>
        </article>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent is-10 is-offset-custom-home-desktop">
        <article class="tile is-child box">
          <h1 class="title"><i class="fa fa-search"></i> File Search</h1>
          <div class="block is-flex">
            <input class="input" v-model="search" type="text" @input="searchFiles()" placeholder="Search">
            <a class="button is-primary">&nbsp;Search</a>
          </div>
          <div class="block is-flex">
            <table class="table is-striped is-narrow ">
              <thead>
              <tr>
                <th></th>
                <th>Size</th>
                <th class="no-break-word">DLs</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="file in searchedfiles">
                <td>{{ file.name }}</td>
                <td class="has-text-centered">{{ file.size | prettyBytes }}</td>
                <td class="has-text-centered">{{ file.downloads }}</td>
                <td><a :href="'/file/'+file.randname"><i :style="'margin-left:18%;'"
                                                         class="fa fa-lg fa-cloud-download"></i> </a></td>
              </tr>
              </tbody>
            </table>
          </div>
        </article>
      </div>
    </div>

  </div>
  <!--<back-to-top target=".is-top">-->
  <!--<h3 class="title"><i class="fa  fa-arrow-up"></i></h3>-->
  <!--</back-to-top>-->
</template>

<script>
  import { BackToTop } from 'vue-bulma-jump'

  let timeout = null
  export default {
    components: {
      BackToTop
    },
    metaInfo: {
      title: 'FilesBeast',
      // override the parent template and just use the above title only
      titleTemplate: null,
      meta: [
        {name: 'description', content: 'FilesBeast is a completely free file sharing service. Download files free, securely, anonymously, without limits.'},
        {name: 'keywords', content: 'file downloads, file hosting, file sharing, fast file downloads'}
      ]
    },
    data () {
      return {
        uploadedfiles: [],
        search: '',
        searchedfiles: [],
        popularfiles: [],
        pagetop: 0,
        next: 0,
        numpages: 0,
        currentElem: false
      }
    },
    methods: {
      searchFiles () {
        clearTimeout(timeout)
        let self = this
        // Make a new timeout set to go off in 800ms
        timeout = setTimeout(function () {
          if (self.search !== '') {
            self.$http({
              url: '/api/v1/search/' + self.search
            }).then((response) => {
              self.searchedfiles = []
              self.searchedfiles.push(...response.data.files)
            }).catch((error) => {
              console.log(error)
            })
          }
        }, 300)
      },
      fetchPage (pagenum, event) {
        if (event) {
          if (this.currentElem) {
            this.currentElem.className = 'pagination-next '
          }
          this.currentElem = event.currentTarget
          this.currentElem.className += 'is-active-page'
        }
        this.$http({
          url: '/api/v1/page/' + pagenum,
          transformResponse: [(data) => {
            return JSON.parse(data.replace(/T00:00:00Z/g, ''))
          }]
        }).then((response) => {
          this.uploadedfiles = response.data.files
          if (pagenum === 1) {
            this.pagetop = response.data.rowcnt
            // calculate number of pages
            this.numpages = Math.ceil(this.pagetop / 10)
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    created () {
      // fetch latest files data
      this.fetchPage(1, false)

      // fetch popular files
      this.$http({
        url: '/api/v1/search/popular',
        transformResponse: [(data) => {
          return JSON.parse(data.replace(/T00:00:00Z/g, ''))
        }]
      }).then((response) => {
        this.popularfiles.push(...response.data.files)
      }).catch((error) => {
        console.log(error)
      })
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .table td, .table th {
    word-break: break-word;
    font-size: 95%;
    padding: 5px;
  }

  .title {
    color: #344;
    margin-bottom: 2px;
  }

  th {
    text-align: center;
  }

  td:nth-child(3n+2), td:nth-child(4n+3) {
    word-break: normal !important;
    white-space: nowrap;
  }

  th:nth-child(3), th:nth-child(2) {
    word-break: normal;
    white-space: nowrap;
  }

  .pagination-list {
    float: right;
  }

  .block:not(:last-child) {
    margin-bottom: 0;
  }

  .is-active-page {
    border-color: #00d1b2;
  }

  .bottom-padding-box {

    padding-bottom: 50px;
  }

  @media screen and (min-width: 1000px) {
    .is-offset-custom-home-desktop {
      margin-left: 1.8%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?774a07b6